import React from 'react';
import styled from 'styled-components';
import { navigate } from 'gatsby';
import appConfig from '../../../../../../app-config';
import InternalLoyaltyCardBalanceWrapper from '../InternalLoyaltyCardBalanceWrapper';
import {
  Body,
  Headline,
  Title1,
  Title2,
} from '../../../../../components/Typography';

const loyaltyTheme = appConfig.loyaltyTheme || {
  contentBackground: '',
  rewardText: '',
  rewardTextColor: '',
  nextOfferColor: '',
  yourBalanceText: '',
  yourBalanceColor: '',
  balanceText: { singular: '', plural: '' },
  balanceColor: '',
  allRewardsUnlockedTitleText: '',
  allRewardsUnlockedContentText: '',
  progressUnfillColor: '',
  progressFillColor: '',
  brandLogo: '',
};

const LayoutWrapper = styled.div`
  border-radius: 16px;
  overflow: hidden;
  display: grid;
  grid-template-columns: 120px 1fr;
  position: relative;
  box-shadow: 0 5px 16px 0 rgba(66, 59, 112, 0.32);
  max-width: 434px;
  height: ${(props) => (props.layoutStyle === 'offer' ? '293px' : '209px')};
  width: ${(props) => (props.layoutStyle === 'offer' ? '100%' : '314px')};
  background: ${loyaltyTheme.contentBackground};
  @media (min-width: 1551px) {
    height: ${(props) => (props.layoutStyle === 'offer' ? '293px' : '289px')};
    width: ${(props) => (props.layoutStyle === 'offer' ? '100%' : '434px')};
  }
  @media (max-width: 1550px) {
    grid-template-columns: 80px 1fr;
  }

  @media (max-width: 360px) {
    width: ${(props) => (props.layoutStyle === 'offer' ? '100%' : '280px')};
  }
`;

const ContentWrapper = styled.div`
  background: ${loyaltyTheme.contentBackground};
  padding: 35px 0 35px 0;

  @media (max-width: 1550px) {
    padding: 15px 0 15px 0;
  }
`;

const HeaderWrapper = styled.div`
  padding: 0 20px 10px 20px;

  @media (max-width: 1550px) {
    padding: ${(props) =>
      props.layoutStyle == 'menu' ? '0 20px 10px 20px' : '0 20px 30px 20px'};
  }
`;
const FooterWrapper = styled.div`
  height: 50px;
  background-color: #f68626;
  position: absolute;
  bottom: 0;
  width: 100%;
  @media (max-width: 1550px) {
    height: 40px;
  }
`;

const RewardWrapper = styled.div`
  margin-top: 15px;
  font-weight: normal;
  color: ${loyaltyTheme.rewardTextColor};
`;

const RewardTitleText = styled(Body)`
  color: ${loyaltyTheme.rewardTextColor};
`;

const NextOfferText = styled(Title2)`
  color: ${loyaltyTheme.nextOfferColor};
  overflow: hidden;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  font-weight: normal;
  @media (max-width: 1550px) {
    font-size: 16px;
  }
`;

const BalanceWrapper = styled.div`
  display: grid;
`;

const YourBalance = styled(Body)`
  color: ${loyaltyTheme.yourBalanceColor};
`;

const Balance = styled(Title1)`
  color: ${loyaltyTheme.balanceColor};
  @media (max-width: 1550px) {
    font-size: 16px;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  padding-top: 50px;
  justify-content: center;
  @media (max-width: 1550px) {
    padding-top: 20px;
  }
`;
const Text = styled.div`
  font-size: 14px;
  margin-bottom: 5px;
  @media (max-width: 1550px) {
    font-size: 10px;
  }
`;
const ProgressWrapper = styled.div`
  position: absolute;
  bottom: 60px;
  width: 100%;
  padding: 0 20px;
  @media (max-width: 1550px) {
    bottom: 40px;
    padding: 0 10px;
  }
`;
const Logo = styled.img`
  width: 90px;
  height: 90px;
  @media (max-width: 1550px) {
    width: 60px;
    height: 60px;
  }
`;

const Progress = styled.progress`
  width: 100%;
  height: 10px;
  background-color: #ffffff;
  border-radius: 5.5px;

  &::-moz-progress-bar {
  }

  &::-webkit-progress-bar {
    border-radius: 5.5px;
    background-color: #ffffff;
  }

  &::-webkit-progress-value {
    border-radius: 5.5px;
    background-color: #000000;
  }

  @media (max-width: 1550px) {
    height: 8px;
  }
`;

const ChaiiwalaLoyaltyCard = (props) => {
  console.log('loyaltyTheme.contentBackgroundImage', loyaltyTheme);
  return (
    <LayoutWrapper
      layoutStyle={props.layoutStyle}
      onClick={() => navigate('/offers')}
    >
      <ImageWrapper>
        <Logo src={loyaltyTheme.contentBackgroundImage} alt='Chaiiwala Logo' />
      </ImageWrapper>
      <ContentWrapper>
        <Text>Your Balance:</Text>
        <BalanceWrapper>
          <Balance>{`${props.balance} ${
            props.balance === 1
              ? loyaltyTheme.balanceText.singular
              : loyaltyTheme.balanceText.plural
          }`}</Balance>
        </BalanceWrapper>
        <RewardWrapper>
          <Text>Next Reward:</Text>
          {props.nextOfferTitle ? (
            <>
              <NextOfferText>{props.nextOfferTitle}</NextOfferText>{' '}
            </>
          ) : (
            <>
              <NextOfferText>
                {loyaltyTheme.allRewardsUnlockedContentText}
              </NextOfferText>
            </>
          )}
        </RewardWrapper>
      </ContentWrapper>
      <ProgressWrapper>
        <Progress max='100' value={props.nextOfferProgressValue} />
      </ProgressWrapper>
      <FooterWrapper />
    </LayoutWrapper>
  );
};

export default ChaiiwalaLoyaltyCard;
